'use client'
import React, { useState, useEffect } from 'react'
import { useTranslations } from 'next-intl'

import SrpTipOfferIcon from '@/src/assets/svgs/SrpTipOfferIcon'
import SrpTipProtectionIcon from '@/src/assets/svgs/SrpTipProtectionIcon'
import SrpTipSortIcon from '@/src/assets/svgs/SrpTipSortIcon'
import SrpTipBaggageIcon from '@/src/assets/svgs/SrpTipBaggageIcon'
import SrpTipLayoverIcon from '@/src/assets/svgs/SrpTipLayoverIcon'

import { SrpTipBanner } from './srpTipBanner'

const TIPS = [
    { Icon: SrpTipOfferIcon, key: 'srpLoadingTip1' },
    { Icon: SrpTipProtectionIcon, key: 'srpLoadingTip2' },
    { Icon: SrpTipSortIcon, key: 'srpLoadingTip3' },
    { Icon: SrpTipBaggageIcon, key: 'srpLoadingTip4' },
    { Icon: SrpTipLayoverIcon, key: 'srpLoadingTip5' }
]

const SrpTipBannerWrapper: React.FC = () => {
    const t = useTranslations('common')
    const [currentIndex, setCurrentIndex] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % TIPS.length)
        }, 2000)

        return () => clearInterval(interval)
    }, [])

    const currentTip = TIPS[currentIndex]

    return (
        <SrpTipBanner
            key={currentIndex}
            text={t(currentTip.key)}
            Icon={currentTip.Icon}
        />
    )
}

export { SrpTipBannerWrapper }
export default SrpTipBannerWrapper
